module.exports = __webpack_public_path__ + "img/photo-0002.ee7c14d4.jpg";